/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ pct: NonNullable<unknown> }} Deep_Match_Confidence_PctInputs */

const en_deep_match_confidence_pct = /** @type {(inputs: Deep_Match_Confidence_PctInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.pct}% confidence`)
};

const de_deep_match_confidence_pct = /** @type {(inputs: Deep_Match_Confidence_PctInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.pct}% confidence`)
};

const fr_deep_match_confidence_pct = /** @type {(inputs: Deep_Match_Confidence_PctInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.pct}% confidence`)
};

const es_deep_match_confidence_pct = /** @type {(inputs: Deep_Match_Confidence_PctInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.pct}% confidence`)
};

const it_deep_match_confidence_pct = /** @type {(inputs: Deep_Match_Confidence_PctInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.pct}% confidence`)
};

const nl_deep_match_confidence_pct = /** @type {(inputs: Deep_Match_Confidence_PctInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.pct}% confidence`)
};

const pl_deep_match_confidence_pct = /** @type {(inputs: Deep_Match_Confidence_PctInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.pct}% confidence`)
};

const fi_deep_match_confidence_pct = /** @type {(inputs: Deep_Match_Confidence_PctInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.pct}% confidence`)
};

const da_deep_match_confidence_pct = /** @type {(inputs: Deep_Match_Confidence_PctInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.pct}% confidence`)
};

const sv_deep_match_confidence_pct = /** @type {(inputs: Deep_Match_Confidence_PctInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.pct}% confidence`)
};

/**
* | output |
* | --- |
* | "{pct}% confidence" |
*
* @param {Deep_Match_Confidence_PctInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const deep_match_confidence_pct = /** @type {((inputs: Deep_Match_Confidence_PctInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deep_Match_Confidence_PctInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_deep_match_confidence_pct(inputs)
	if (locale === "fr") return fr_deep_match_confidence_pct(inputs)
	if (locale === "es") return es_deep_match_confidence_pct(inputs)
	if (locale === "it") return it_deep_match_confidence_pct(inputs)
	if (locale === "nl") return nl_deep_match_confidence_pct(inputs)
	if (locale === "pl") return pl_deep_match_confidence_pct(inputs)
	if (locale === "fi") return fi_deep_match_confidence_pct(inputs)
	if (locale === "da") return da_deep_match_confidence_pct(inputs)
	if (locale === "sv") return sv_deep_match_confidence_pct(inputs)
	return en_deep_match_confidence_pct(inputs)
});